import MapWithSlider from "./map-with-slider";
export default MapWithSlider;
